import { render, staticRenderFns } from "./evaluate-task-student.vue?vue&type=template&id=14e1b4b3&scoped=true"
import script from "./evaluate-task-student.vue?vue&type=script&lang=js"
export * from "./evaluate-task-student.vue?vue&type=script&lang=js"
import style0 from "./evaluate-task-student.vue?vue&type=style&index=0&id=14e1b4b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e1b4b3",
  null
  
)

export default component.exports